import { gql } from '@apollo/client';
export const templateQuery = gql `
  query GetTemplateName($id: UUID!) {
    template(id: $id) {
      id

      composerTemplates {
        id
        composer {
          id
          metadata {
            name
            marketLocaleCode
          }
        }
      }
    }
  }
`;
